import { render, staticRenderFns } from "./Settings.html?vue&type=template&id=1b10438c&scoped=true&external"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"
import style0 from "./Settings.scss?vue&type=style&index=0&id=1b10438c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b10438c",
  null
  
)

export default component.exports